import { useQuery } from '@tanstack/react-query';

import { companyApi } from '@/lib/api';

import { queryKeys } from './query-keys';

export function useCompanyQuery() {
  return useQuery({
    queryKey: queryKeys.company.info,
    queryFn: () => companyApi.getInfo(),
  });
}
